export const randStr = (length: number): string => {
  let str = ''
  while (str.length < length) {
    str += Math.random()
      .toString(36)
      .substring(2, 2 + Math.min(length - str.length, 8))
  }
  return str
}